
const prod = [
  {
    path: '/',
    name: 'homepage',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/homepage.vue').then(Homepage => {
      return Homepage
    }),
  },
  {
    path: '/results',
    name: 'results',
    props: true,
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/results').then(Results => {
      return Results
    }),
  },
  {
    path: '/detail',
    name: 'detail',
    props: true,
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/detail').then(Detail => {
      return Detail
    }),
  },
  {
    path: '/checkout',
    name: 'checkout',
    props: true,
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/checkout').then(Checkout => {
      return Checkout
    }),
  },
  {
    path: '/confirm/:confirm_code/:itinerary_id',
    name: 'confirm',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/confirm').then(function (Confirm) {
      if (process.env.VUE_APP_MODE != 'production') window.console.log('async: Confirm View loaded')
      return Confirm
    }),
    props: (route) => {
      return {
        confirm_code: route.params.confirm_code,
        itinerary_id: route.params.itinerary_id,
        ignore_redirect: false,
      }
    },
  },
  {
    path: '/prenotazioni/:confirm_code/:itinerary_id',
    name: 'prenotazioni',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/confirm').then(function (Confirm) {
      if (process.env.VUE_APP_MODE != 'production') window.console.log('async: Confirm View loaded')
      return Confirm
    }),
    props: (route) => {
      return {
        confirm_code: route.params.confirm_code,
        itinerary_id: route.params.itinerary_id,
        ignore_redirect: true,
      }
    },
  },
  {
    path: '/doublecheck/:confirmcode/:itinerary_id',
    name: 'doublecheck',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/doublecheck').then(function (Doublecheck) {
      if (process.env.VUE_APP_MODE != 'production') window.console.log('async: Doublecheck View loaded')
      return Doublecheck
    }),
    props: (route) => {
      return {
        confirmcode: route.params.confirmcode,
        itinerary_id: route.params.itinerary_id,
      }
    },
  },
  {
    path: '/termini-e-condizioni',
    name: 'terms',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/static-pages/terms').then(function (Terms) {
      return Terms
    }),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(process.env.VUE_APP_SITE_URL + '/components/views/static-pages/about.vue').then(function (About) {
      return About
    }),
  },
  {
    path: '/loyalty',
    name: 'promo-loyalty',
    component: () => import('@running_app_src/components/views/static-pages/promo-loyalty.vue').then(function (PromoLoyalty) {
      return PromoLoyalty
    }),
  },
  {
    path: "/invadobay/:slug",
    name: "invadobay",
    component: () =>
      import(
        process.env.VUE_APP_SITE_URL + "/components/views/invadobay.vue"
      ).then(function (LandingPage) {
        return LandingPage;
      }),
    props: (route) => {
      return {
        slug: route.params.slug
      };
    },
  },
]

export {
  prod
}
